module.exports = __webpack_public_path__ + "img/banner_01.24d51dbf.png";